import { Moon, Sun } from 'lucide-react'
import { useSettings } from '@/contexts/SettingsContext'
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip'
import './theme-toggle-button.css'

export function ThemeToggleButton() {
	const { theme, setTheme } = useSettings()
	const effectiveTheme = theme === 'system'
		? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
		: theme

	const isDark = effectiveTheme === 'dark'

	function handleToggle() {
		setTheme(isDark ? 'light' : 'dark')
	}

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					onClick={handleToggle}
					className="theme-toggle-button"
					aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
				>
					{isDark ? <Sun className="theme-toggle-icon" /> : <Moon className="theme-toggle-icon" />}
				</button>
			</TooltipTrigger>
			<TooltipContent>
				{isDark ? 'Light mode' : 'Dark mode'}
			</TooltipContent>
		</Tooltip>
	)
}
